/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull customer_portal'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 3
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest)
 *
 * [Full Setup Instructions](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/implementation/customer_portal)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'arivocrmproduction';

export const ApiKey: Record<Environment, string> = {
  arivocrmproduction: 'd368406ba95dc3a4e77bf2ef9abe7469'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '3',
    branch: 'main',
    source: 'customer_portal',
    versionId: 'b257cd13-7555-4b30-9b0f-2a08f41bc46b'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  },
  serverZone: amplitude.Types.ServerZone.EU
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  contractCount?: number;
  hasInvoiceAddress?: boolean;
  hasPpuEnabled?: boolean;
  isBusinessAccount?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  licensePlatesCount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  licensePlatesPpuEnabledCount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | scheme, sepadirectdebit, googlepay, applepay |
   */
  paymentMethod?: "scheme" | "sepadirectdebit" | "googlepay" | "applepay";
  providerName?: string;
}

export interface AccessCodeShownProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | dashboard, contracts_create, contracts_edit, products, vehicles, billing, login, onboarding, onboarding_finish, data, help, terms_and_conditions, data_privacy, imprint, accessibility, access_card, error, public_products |
   */
  referredByPage:
    | "dashboard"
    | "contracts_create"
    | "contracts_edit"
    | "products"
    | "vehicles"
    | "billing"
    | "login"
    | "onboarding"
    | "onboarding_finish"
    | "data"
    | "help"
    | "terms_and_conditions"
    | "data_privacy"
    | "imprint"
    | "accessibility"
    | "access_card"
    | "error"
    | "public_products";
}

export interface ContractCreateCancelledProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  contractType: "contract" | "ppu";
}

export interface ContractCreateLicensePlateAddedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  contractParkingSpacesAvailable: number;
  contractParkingSpacesLimitMet: boolean;
  contractParkingSpacesLimitOver: boolean;
  contractParkingSpacesLimitUnder: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  contractParkingSpacesUsed: number;
}

export interface ContractCreateLicensePlateRemovedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  contractParkingSpacesAvailable: number;
  contractParkingSpacesLimitMet: boolean;
  contractParkingSpacesLimitOver: boolean;
  contractParkingSpacesLimitUnder: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  contractParkingSpacesUsed: number;
}

export interface ContractCreateOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  contractType: "contract" | "ppu";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | dashboard, contracts_create, contracts_edit, products, vehicles, billing, login, onboarding, onboarding_finish, data, help, terms_and_conditions, data_privacy, imprint, accessibility, access_card, error, public_products |
   */
  referredByPage:
    | "dashboard"
    | "contracts_create"
    | "contracts_edit"
    | "products"
    | "vehicles"
    | "billing"
    | "login"
    | "onboarding"
    | "onboarding_finish"
    | "data"
    | "help"
    | "terms_and_conditions"
    | "data_privacy"
    | "imprint"
    | "accessibility"
    | "access_card"
    | "error"
    | "public_products";
}

export interface ContractCreateSavedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  contractType: "contract" | "ppu";
}

export interface ContractEditCancelledProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  contractType: "contract" | "ppu";
}

export interface ContractEditLicensePlateAddedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  contractParkingSpacesAvailable: number;
  contractParkingSpacesLimitMet: boolean;
  contractParkingSpacesLimitOver: boolean;
  contractParkingSpacesLimitUnder: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  contractParkingSpacesUsed: number;
}

export interface ContractEditLicensePlateRemovedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  contractParkingSpacesAvailable: number;
  contractParkingSpacesLimitMet: boolean;
  contractParkingSpacesLimitOver: boolean;
  contractParkingSpacesLimitUnder: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  contractParkingSpacesUsed: number;
}

export interface ContractEditOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | dashboard, contracts_create, contracts_edit, products, vehicles, billing, login, onboarding, onboarding_finish, data, help, terms_and_conditions, data_privacy, imprint, accessibility, access_card, error, public_products |
   */
  referredByPage:
    | "dashboard"
    | "contracts_create"
    | "contracts_edit"
    | "products"
    | "vehicles"
    | "billing"
    | "login"
    | "onboarding"
    | "onboarding_finish"
    | "data"
    | "help"
    | "terms_and_conditions"
    | "data_privacy"
    | "imprint"
    | "accessibility"
    | "access_card"
    | "error"
    | "public_products";
}

export interface ContractEditSavedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  contractType: "contract" | "ppu";
}

export interface ContractEditTerminateSubmittedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  daysLeftInContract: number;
}

export interface InvoiceDownloadedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  invoiceAgeInDays: number;
  invoiceHasAdditionalFees: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | draft, open, cleared, uncollectible, deducted, refunded, nonrefundable |
   */
  invoiceStatus: "draft" | "open" | "cleared" | "uncollectible" | "deducted" | "refunded" | "nonrefundable";
}

export interface LanguageChangedProperties {
  newLanguage: string;
  previousLanguage: string;
}

export interface PaymentMethodAddClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | add, update |
   */
  paymentMethodChangeType: "add" | "update";
}

export interface PaymentMethodAddFailedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | direct, iframe |
   */
  adyenIntegrationType: "direct" | "iframe";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | add, update |
   */
  paymentMethodChangeType: "add" | "update";
}

export interface PaymentMethodAddSucceededProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | direct, iframe |
   */
  adyenIntegrationType: "direct" | "iframe";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | sepadirectdebit, scheme, googlepay, applepay |
   */
  paymentMethod: "sepadirectdebit" | "scheme" | "googlepay" | "applepay";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | add, update |
   */
  paymentMethodChangeType: "add" | "update";
}

export interface PayPerUseLicensePlateAddedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  totalAmountOfLicensePlates: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  totalNumberOfEnabledLicensePlates: number;
}

export interface PayPerUseLicensePlateRemovedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  totalAmountOfLicensePlates: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  totalNumberOfEnabledLicensePlates: number;
}

export interface RegistrationEmailSubmittedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  registrationFlowType: "contract" | "ppu";
}

export interface RegistrationEmailValidatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  registrationFlowType: "contract" | "ppu";
}

export interface RegistrationLicensePlateSubmittedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  registrationFlowType: "contract" | "ppu";
}

export interface RegistrationParkingSessionStatusFetchedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  registrationFlowType: "contract" | "ppu";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | cleared_session, active_access, open_session, no_session |
   */
  registrationParkingSessionStatus: "cleared_session" | "active_access" | "open_session" | "no_session";
}

export interface RegistrationResendEmailClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  registrationFlowType: "contract" | "ppu";
}

export interface RegistrationStartedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | contract, ppu |
   */
  registrationFlowType: "contract" | "ppu";
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AccessCodeShown implements BaseEvent {
  event_type = 'AccessCodeShown';

  constructor(
    public event_properties: AccessCodeShownProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractCreateCancelled implements BaseEvent {
  event_type = 'ContractCreateCancelled';

  constructor(
    public event_properties: ContractCreateCancelledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractCreateLicensePlateAdded implements BaseEvent {
  event_type = 'ContractCreateLicensePlateAdded';

  constructor(
    public event_properties: ContractCreateLicensePlateAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractCreateLicensePlateRemoved implements BaseEvent {
  event_type = 'ContractCreateLicensePlateRemoved';

  constructor(
    public event_properties: ContractCreateLicensePlateRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractCreateOpened implements BaseEvent {
  event_type = 'ContractCreateOpened';

  constructor(
    public event_properties: ContractCreateOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractCreateSaved implements BaseEvent {
  event_type = 'ContractCreateSaved';

  constructor(
    public event_properties: ContractCreateSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractEditCancelled implements BaseEvent {
  event_type = 'ContractEditCancelled';

  constructor(
    public event_properties: ContractEditCancelledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractEditLicensePlateAdded implements BaseEvent {
  event_type = 'ContractEditLicensePlateAdded';

  constructor(
    public event_properties: ContractEditLicensePlateAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractEditLicensePlateRemoved implements BaseEvent {
  event_type = 'ContractEditLicensePlateRemoved';

  constructor(
    public event_properties: ContractEditLicensePlateRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractEditOpened implements BaseEvent {
  event_type = 'ContractEditOpened';

  constructor(
    public event_properties: ContractEditOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractEditSaved implements BaseEvent {
  event_type = 'ContractEditSaved';

  constructor(
    public event_properties: ContractEditSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContractEditTerminateCancelled implements BaseEvent {
  event_type = 'ContractEditTerminateCancelled';
}

export class ContractEditTerminateClicked implements BaseEvent {
  event_type = 'ContractEditTerminateClicked';
}

export class ContractEditTerminateSubmitted implements BaseEvent {
  event_type = 'ContractEditTerminateSubmitted';

  constructor(
    public event_properties: ContractEditTerminateSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InvoiceDownloaded implements BaseEvent {
  event_type = 'InvoiceDownloaded';

  constructor(
    public event_properties: InvoiceDownloadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LanguageChanged implements BaseEvent {
  event_type = 'LanguageChanged';

  constructor(
    public event_properties: LanguageChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LoggedIn implements BaseEvent {
  event_type = 'LoggedIn';
}

export class LoggedOut implements BaseEvent {
  event_type = 'LoggedOut';
}

export class PaymentMethodAddClicked implements BaseEvent {
  event_type = 'PaymentMethodAddClicked';

  constructor(
    public event_properties: PaymentMethodAddClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PaymentMethodAddFailed implements BaseEvent {
  event_type = 'PaymentMethodAddFailed';

  constructor(
    public event_properties: PaymentMethodAddFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PaymentMethodAddSucceeded implements BaseEvent {
  event_type = 'PaymentMethodAddSucceeded';

  constructor(
    public event_properties: PaymentMethodAddSucceededProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PayPerUseLicensePlateAdded implements BaseEvent {
  event_type = 'PayPerUseLicensePlateAdded';

  constructor(
    public event_properties: PayPerUseLicensePlateAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PayPerUseLicensePlateRemoved implements BaseEvent {
  event_type = 'PayPerUseLicensePlateRemoved';

  constructor(
    public event_properties: PayPerUseLicensePlateRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RegistrationEmailSubmitted implements BaseEvent {
  event_type = 'RegistrationEmailSubmitted';

  constructor(
    public event_properties: RegistrationEmailSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RegistrationEmailValidated implements BaseEvent {
  event_type = 'RegistrationEmailValidated';

  constructor(
    public event_properties: RegistrationEmailValidatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RegistrationLicensePlateSubmitted implements BaseEvent {
  event_type = 'RegistrationLicensePlateSubmitted';

  constructor(
    public event_properties: RegistrationLicensePlateSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RegistrationParkingSessionStatusFetched implements BaseEvent {
  event_type = 'RegistrationParkingSessionStatusFetched';

  constructor(
    public event_properties: RegistrationParkingSessionStatusFetchedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RegistrationResendEmailClicked implements BaseEvent {
  event_type = 'RegistrationResendEmailClicked';

  constructor(
    public event_properties: RegistrationResendEmailClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RegistrationStarted implements BaseEvent {
  event_type = 'RegistrationStarted';

  constructor(
    public event_properties: RegistrationStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * AccessCodeShown
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/AccessCodeShown)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. referredByPage)
   * @param options Amplitude event options.
   */
  accessCodeShown(
    properties: AccessCodeShownProperties,
    options?: EventOptions,
  ) {
    return this.track(new AccessCodeShown(properties), options);
  }

  /**
   * ContractCreateCancelled
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractCreateCancelled)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. contractType)
   * @param options Amplitude event options.
   */
  contractCreateCancelled(
    properties: ContractCreateCancelledProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractCreateCancelled(properties), options);
  }

  /**
   * ContractCreateLicensePlateAdded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractCreateLicensePlateAdded)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. contractParkingSpacesAvailable)
   * @param options Amplitude event options.
   */
  contractCreateLicensePlateAdded(
    properties: ContractCreateLicensePlateAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractCreateLicensePlateAdded(properties), options);
  }

  /**
   * ContractCreateLicensePlateRemoved
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractCreateLicensePlateRemoved)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. contractParkingSpacesAvailable)
   * @param options Amplitude event options.
   */
  contractCreateLicensePlateRemoved(
    properties: ContractCreateLicensePlateRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractCreateLicensePlateRemoved(properties), options);
  }

  /**
   * ContractCreateOpened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractCreateOpened)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. contractType)
   * @param options Amplitude event options.
   */
  contractCreateOpened(
    properties: ContractCreateOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractCreateOpened(properties), options);
  }

  /**
   * ContractCreateSaved
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractCreateSaved)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. contractType)
   * @param options Amplitude event options.
   */
  contractCreateSaved(
    properties: ContractCreateSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractCreateSaved(properties), options);
  }

  /**
   * ContractEditCancelled
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractEditCancelled)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. contractType)
   * @param options Amplitude event options.
   */
  contractEditCancelled(
    properties: ContractEditCancelledProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractEditCancelled(properties), options);
  }

  /**
   * ContractEditLicensePlateAdded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractEditLicensePlateAdded)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. contractParkingSpacesAvailable)
   * @param options Amplitude event options.
   */
  contractEditLicensePlateAdded(
    properties: ContractEditLicensePlateAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractEditLicensePlateAdded(properties), options);
  }

  /**
   * ContractEditLicensePlateRemoved
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractEditLicensePlateRemoved)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. contractParkingSpacesAvailable)
   * @param options Amplitude event options.
   */
  contractEditLicensePlateRemoved(
    properties: ContractEditLicensePlateRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractEditLicensePlateRemoved(properties), options);
  }

  /**
   * ContractEditOpened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractEditOpened)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. referredByPage)
   * @param options Amplitude event options.
   */
  contractEditOpened(
    properties: ContractEditOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractEditOpened(properties), options);
  }

  /**
   * ContractEditSaved
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractEditSaved)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. contractType)
   * @param options Amplitude event options.
   */
  contractEditSaved(
    properties: ContractEditSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractEditSaved(properties), options);
  }

  /**
   * ContractEditTerminateCancelled
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractEditTerminateCancelled)
   *
   * Owner: Philip Kasper
   *
   * @param options Amplitude event options.
   */
  contractEditTerminateCancelled(
    options?: EventOptions,
  ) {
    return this.track(new ContractEditTerminateCancelled(), options);
  }

  /**
   * ContractEditTerminateClicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractEditTerminateClicked)
   *
   * Owner: Philip Kasper
   *
   * @param options Amplitude event options.
   */
  contractEditTerminateClicked(
    options?: EventOptions,
  ) {
    return this.track(new ContractEditTerminateClicked(), options);
  }

  /**
   * ContractEditTerminateSubmitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/ContractEditTerminateSubmitted)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. daysLeftInContract)
   * @param options Amplitude event options.
   */
  contractEditTerminateSubmitted(
    properties: ContractEditTerminateSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContractEditTerminateSubmitted(properties), options);
  }

  /**
   * InvoiceDownloaded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/InvoiceDownloaded)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. invoiceAgeInDays)
   * @param options Amplitude event options.
   */
  invoiceDownloaded(
    properties: InvoiceDownloadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InvoiceDownloaded(properties), options);
  }

  /**
   * LanguageChanged
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/LanguageChanged)
   *
   * User changed language of customer  portal
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. newLanguage)
   * @param options Amplitude event options.
   */
  languageChanged(
    properties: LanguageChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LanguageChanged(properties), options);
  }

  /**
   * LoggedIn
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/LoggedIn)
   *
   * Owner: Philip Kasper
   *
   * @param options Amplitude event options.
   */
  loggedIn(
    options?: EventOptions,
  ) {
    return this.track(new LoggedIn(), options);
  }

  /**
   * LoggedOut
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/LoggedOut)
   *
   * User logged out of customer portal
   *
   * Owner: Philip Kasper
   *
   * @param options Amplitude event options.
   */
  loggedOut(
    options?: EventOptions,
  ) {
    return this.track(new LoggedOut(), options);
  }

  /**
   * PaymentMethodAddClicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/PaymentMethodAddClicked)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. paymentMethodChangeType)
   * @param options Amplitude event options.
   */
  paymentMethodAddClicked(
    properties: PaymentMethodAddClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaymentMethodAddClicked(properties), options);
  }

  /**
   * PaymentMethodAddFailed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/PaymentMethodAddFailed)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. adyenIntegrationType)
   * @param options Amplitude event options.
   */
  paymentMethodAddFailed(
    properties: PaymentMethodAddFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaymentMethodAddFailed(properties), options);
  }

  /**
   * PaymentMethodAddSucceeded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/PaymentMethodAddSucceeded)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. adyenIntegrationType)
   * @param options Amplitude event options.
   */
  paymentMethodAddSucceeded(
    properties: PaymentMethodAddSucceededProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaymentMethodAddSucceeded(properties), options);
  }

  /**
   * PayPerUseLicensePlateAdded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/PayPerUseLicensePlateAdded)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. totalAmountOfLicensePlates)
   * @param options Amplitude event options.
   */
  payPerUseLicensePlateAdded(
    properties: PayPerUseLicensePlateAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PayPerUseLicensePlateAdded(properties), options);
  }

  /**
   * PayPerUseLicensePlateRemoved
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/PayPerUseLicensePlateRemoved)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. totalAmountOfLicensePlates)
   * @param options Amplitude event options.
   */
  payPerUseLicensePlateRemoved(
    properties: PayPerUseLicensePlateRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PayPerUseLicensePlateRemoved(properties), options);
  }

  /**
   * RegistrationEmailSubmitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/RegistrationEmailSubmitted)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. registrationFlowType)
   * @param options Amplitude event options.
   */
  registrationEmailSubmitted(
    properties: RegistrationEmailSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RegistrationEmailSubmitted(properties), options);
  }

  /**
   * RegistrationEmailValidated
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/RegistrationEmailValidated)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. registrationFlowType)
   * @param options Amplitude event options.
   */
  registrationEmailValidated(
    properties: RegistrationEmailValidatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RegistrationEmailValidated(properties), options);
  }

  /**
   * RegistrationLicensePlateSubmitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/RegistrationLicensePlateSubmitted)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. registrationFlowType)
   * @param options Amplitude event options.
   */
  registrationLicensePlateSubmitted(
    properties: RegistrationLicensePlateSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RegistrationLicensePlateSubmitted(properties), options);
  }

  /**
   * RegistrationParkingSessionStatusFetched
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/RegistrationParkingSessionStatusFetched)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. registrationFlowType)
   * @param options Amplitude event options.
   */
  registrationParkingSessionStatusFetched(
    properties: RegistrationParkingSessionStatusFetchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RegistrationParkingSessionStatusFetched(properties), options);
  }

  /**
   * RegistrationResendEmailClicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/RegistrationResendEmailClicked)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. registrationFlowType)
   * @param options Amplitude event options.
   */
  registrationResendEmailClicked(
    properties: RegistrationResendEmailClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RegistrationResendEmailClicked(properties), options);
  }

  /**
   * RegistrationStarted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/arivo/Arivo%20CRM%20-%20Production/events/main/latest/RegistrationStarted)
   *
   * Owner: Philip Kasper
   *
   * @param properties The event's properties (e.g. registrationFlowType)
   * @param options Amplitude event options.
   */
  registrationStarted(
    properties: RegistrationStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RegistrationStarted(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
